import PCLNAnalytics from '@pcln/analytics';
class Analytics {
  constructor() {
    this.pclnAnalytics = PCLNAnalytics;
  }
  init(data) {
    this.chatbotContext = data;
  }
  // fire GA4 event
  fireGA4Event(ga4EventParams) {
    this.pclnAnalytics.GA4Enabled = true;
    this.pclnAnalytics.logEvent(ga4EventParams);
  }
  // Log an error
  // sample query 'index=cheetah component=PennyChatbot action=error'
  logError(logData) {
    this.pclnAnalytics.logError(Object.assign(Object.assign({}, this.getBaseAttributes()), logData));
  }
  // Log directly to Splunk
  // sample query 'index=cheetah component=PennyChatbot'
  log(logData) {
    this.pclnAnalytics.log(Object.assign(Object.assign({}, this.getBaseAttributes()), logData));
  }
  getBaseAttributes() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return {
      component: 'PennyChatbot',
      requestFrom: (_c = (_b = (_a = this.chatbotContext) === null || _a === void 0 ? void 0 : _a.fetchRequestOptions) === null || _b === void 0 ? void 0 : _b.headers) === null || _c === void 0 ? void 0 : _c['x-request-from'],
      productId: (_e = (_d = this.chatbotContext) === null || _d === void 0 ? void 0 : _d.submitChatMessagesPayload) === null || _e === void 0 ? void 0 : _e.productId,
      cguid: (_g = (_f = this.chatbotContext) === null || _f === void 0 ? void 0 : _f.submitChatMessagesPayload) === null || _g === void 0 ? void 0 : _g.cguid,
      rguid: (_j = (_h = this.chatbotContext) === null || _h === void 0 ? void 0 : _h.submitChatMessagesPayload) === null || _j === void 0 ? void 0 : _j.rguid
    };
  }
}
export default new Analytics();